const Arrows = (props) => (
  <svg
    width={24}
    height={72}
    viewBox="0 0 24 72"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <path
      d="M4 17V27H19M16 23L20 27L16 31"
      stroke="#E1E1E2"
      strokeWidth={2}
      strokeLinecap="square"
    />
    <path
      d="M4 53V63H19M16 59L20 63L16 67"
      stroke="#E1E1E2"
      strokeWidth={2}
      strokeLinecap="square"
    />
    <line x1={4} y1={-4.37114e-8} x2={4} y2={64} stroke="#E1E1E2" strokeWidth={2} />
  </svg>
)
export default Arrows
